import LoLLanguageProvider from './LoLLanguageProvider';

export default LoLLanguageProvider;
